const Cog = () => {
    return (
        <img src={process.env.PUBLIC_URL + "/cog.svg"} alt="Settings" />
    )
}

export default Cog;